// styles
import {
    InputDropdownWrapper,
    InputDropdownControl,
    InputDropdownSelect,
    InputDropdownLabel,
    InputDropdownIcon
} from './InputDropdown.styles';

// icons
import { KeyboardArrowDown } from '@mui/icons-material';

export default function InputDropdown({ 
    options, 
    onChange, 
    defaultValue, 
    value, 
    id, 
    children,
    placeholder,
    label,
    className = 'widget-bg',
    size = 'default', // 'default' or 'compact'
    align = 'left'
}) {
    const selectedValue = value !== undefined ? value : defaultValue || '';
    const hasLabel = !!(label || placeholder);

    const handleChange = (e) => {
        const newValue = e.target.value;
        onChange?.(newValue); // optional callback
    };

    const resolvedAlign = align === 'center' ? 'center' : 'left';

    return (
        <InputDropdownWrapper $size={size} $align={resolvedAlign}>
            {hasLabel && (
                <InputDropdownLabel $size={size} $align={resolvedAlign}>
                    {label || placeholder}
                </InputDropdownLabel>
            )}
            <InputDropdownControl $size={size}>
                <InputDropdownSelect 
                    id={id} 
                    value={selectedValue} 
                    onChange={handleChange} 
                    className={className}
                    $size={size}
                    $align={resolvedAlign}
                >
                    {placeholder && <option value="">{placeholder}</option>}
                    {children || options?.map((opt, idx) => (
                        <option key={idx} value={opt}>
                            {opt}
                        </option>
                    ))}
                </InputDropdownSelect>
                <InputDropdownIcon $size={size}>
                    <KeyboardArrowDown />
                </InputDropdownIcon>
            </InputDropdownControl>
        </InputDropdownWrapper>
    )
};
